import React, { useEffect, useState, useCallback} from "react";
import { Modal, Table, Button, Input, message, Tree, Checkbox, Spin, Radio } from "antd";
import axios from "axios";
import 'antd/dist/reset.css';
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { endpoints } from './caminhoApi';

const CLASS_TYPES = ["Hunted", "Prioridade", "Bomba", "Maker"];

export default function ClassificacaoModal({ visible, onClose, fetchClassificacoes, semGuildList, updateSemGuildList }) {
  const [guild, setGuild] = useState("Eternity");
  const [searchTerm, setSearchTerm] = useState("");
  const [treeSearch, setTreeSearch] = useState("");
  const [players, setPlayers] = useState([]);
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [selectedClassified, setSelectedClassified] = useState([]);
  const [classificacoes, setClassificacoes] = useState({});
  const [loading, setLoading] = useState(false);
  const [, setSaving] = useState(false);
  const [id, setId] = useState(sessionStorage.getItem('id') || '');
  const [senha, setSenha] = useState(sessionStorage.getItem('senha') || '');
  const [authenticated, setAuthenticated] = useState(false);
  const [autoAuthTried, setAutoAuthTried] = useState(false); // para não tentar autenticar toda hora

  // estados:
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchResult, setSearchResult] = useState(null);
  const [modalSearchTerm, setModalSearchTerm] = useState(""); // usado só no modal
  const [isSearching, setIsSearching] = useState(false);
  const [isSaving, setIsSaving] = useState(false);  // Adiciona o estado isSaving

  const handleSave = () => {
    setIsSaving(true);  // Ativa o loading do botão de salvar
    
    if (semGuildList.some(p => p.name === searchResult.name)) {
      message.info("Jogador já está na lista.");
      setIsSaving(false);  // Desativa o loading se já estiver na lista
      return;
    }

    axios.post(endpoints.semGuildEndpoint, searchResult).then(() => {
      axios.get(endpoints.semGuildEndpoint).then((res) => {
        updateSemGuildList(res.data);
        fetchGuildMembers("");  // Recarrega a lista de sem guild
        //onClose();
        message.success("Adicionado com sucesso.");
        setIsSaving(false);  // Desativa o loading após o salvamento
      });
    }).catch(() => {
      setIsSaving(false);  // Desativa o loading em caso de erro
      message.error("Erro ao salvar jogador.");
    });
  };

  const handleAuthentication = useCallback(async (auto = false) => {
    const storedAuthenticated = sessionStorage.getItem('authenticated') === 'true';
    
    if (storedAuthenticated) {
      setAuthenticated(true);
      return;
    }

    if (!id || !senha) {
      if (!auto) message.error("Preencha ID e senha!");
      return;
    }

    try {
      const response = await axios.post(endpoints.loginEndpoint, { id, senha });

      if (response.status === 200) {
        setAuthenticated(true);
        if (!auto) message.success("Autenticação bem-sucedida.");

        sessionStorage.setItem('authenticated', 'true');
        sessionStorage.setItem('id', id);
        sessionStorage.setItem('senha', senha);
      }
    } catch (error) {
      if (!auto) {
        message.error("ID ou senha incorretos.");
      }
    }
  }, [id, senha]);  // depende só de id e senha

  const fetchGuildMembers = useCallback(async (guildName) => {
    setLoading(true);
    try {
      if (guildName === "") {
        // Quando "Sem Guild" estiver selecionado
        const res = await axios.get(endpoints.semGuildEndpoint);
        setPlayers(res.data);
      } else {
        const res = await axios.get(`${endpoints.guildMemberEndpoint}?guild=${encodeURIComponent(guildName)}`);
        setPlayers(res.data);
      }
    } catch {
      message.error(guildName === "" ? "Erro ao buscar jogadores sem guild." : "Erro ao buscar membros da guild.");
    } finally {
      setLoading(false);
    }
  }, []); // Não depende de nada externo além de setPlayers/setLoading/message, que são estáveis

  useEffect(() => {
    if (visible && !authenticated && !autoAuthTried) {
      if (id && senha) handleAuthentication(true);
      setAutoAuthTried(true);
    }
  }, [visible, authenticated, autoAuthTried, id, senha, handleAuthentication]);
  
    useEffect(() => {
      if (authenticated && visible) {
        fetchClassificacoess();
        fetchGuildMembers(guild);
        setSelectedPlayers([]);
        setSelectedClassified([]);
      }
    }, [authenticated, visible, guild, fetchGuildMembers]);

    useEffect(() => {
      if (authenticated && visible) {
        fetchGuildMembers(guild);
        setSelectedPlayers([]);
        setSelectedClassified([]);
      }
    }, [authenticated, visible, guild, fetchGuildMembers]);

    useEffect(() => {
      const storedAuthenticated = sessionStorage.getItem('authenticated') === 'true';
      
      if (storedAuthenticated) {
        setAuthenticated(true);
      } else if (id && senha) {
        handleAuthentication(true);
      }

      setAutoAuthTried(true);
    }, [visible, handleAuthentication, id, senha]);

  const handleClose = () => {
    onClose();
    setAuthenticated(false); // limpar autenticação ao fechar
    setAutoAuthTried(false);  // permitir nova tentativa ao abrir
    setSearchTerm("");
    setTreeSearch("");
    //window.location.reload();
  };

  const fetchClassificacoess = async () => {
    try {
      const res = await axios.get(endpoints.classEndpoint);
      //const res = await axios.get(endpoints.classEndpoint);

      setClassificacoes(res.data || {});
    } catch {
      message.error("Erro ao carregar classificações.");
    }
  };

  const handleConfirmClassification = (tipo) => {
    Modal.confirm({
      title: `Classificar ${selectedPlayers.length} jogadores como ${tipo}?`,
      onOk: async () => {
        setSaving(true);
        try {
          const updated = { ...classificacoes };
          selectedPlayers.forEach(name => {
            const player = players.find(p => p.name === name);
            if (player) {
              updated[name] = {
                tipo,
                guild,
                vocation: player.vocation,
                level: player.level
              };
            }
          });

          await axios.post(endpoints.classEndpoint, updated);
          message.success(`${tipo} salvos com sucesso!`);
          fetchClassificacoes();
          setClassificacoes(updated);
          fetchGuildMembers(guild);
          setSelectedPlayers([]);
          setSelectedClassified([]);
        } catch (error) {
          console.error("Erro ao classificar:", error);
          const errMsg = error.response?.data?.error || "Erro ao salvar classificações.";
          message.error(errMsg);
        } finally {
          setSaving(false);
        }
      },
    });
  };

  const handleRemoveMultiple = () => {
    Modal.confirm({
      title: `Remover ${selectedClassified.length} jogadores classificados?`,
      onOk: async () => {
        setSaving(true);
        try {
          const updated = { ...classificacoes };
          selectedClassified.forEach(name => {
            delete updated[name];
          });

          await axios.post(endpoints.classEndpoint, updated);
          message.success(`Classificações removidas com sucesso!`);
          fetchClassificacoes();
          setClassificacoes(updated);
          fetchGuildMembers(guild);
          setSelectedPlayers([]);
          setSelectedClassified([]);
        } catch (error) {
          console.error("Erro ao remover:", error);
          const errMsg = error.response?.data?.error || "Erro ao remover classificações.";
          message.error(errMsg);
        } finally {
          setSaving(false);
        }
      },
    });
  };

  const handlePlayerSelection = (selectedRowKeys) => {
    setSelectedPlayers(prevSelected => {
      const updatedSelected = new Set(prevSelected);
      selectedRowKeys.forEach(player => updatedSelected.add(player));
      return [...updatedSelected];
    });
  };

  const filteredPlayers = players.filter(p =>
    (!classificacoes[p.name] || classificacoes[p.name]?.guild !== guild) &&
    p.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
    !selectedPlayers.includes(p.name)
  );

  const columns = [
    { title: "Nome", dataIndex: "name", width: 130, sorter: (a, b) => a.name.localeCompare(b.name) },
    { title: "Vocação", dataIndex: "vocation", width: 80, sorter: (a, b) => a.vocation.localeCompare(b.vocation) },
    { title: "Level", dataIndex: "level", width: 50, sorter: (a, b) => a.level - b.level },
    
  ];

  const columnsFinal = guild === ""
  ? [
      ...columns,
      {
        title: "Mundo",
        dataIndex: "world",
        width: 80,
        filters: [
          { text: "Solidera", value: "Solidera" },
          { text: "Havera", value: "Havera" },
          // Adicione outros mundos aqui
        ]
        .sort((a, b) => a.text.localeCompare(b.text)), // Ordena os filtros alfabeticamente
        onFilter: (value, record) => record.world === value,
        sorter: (a, b) => a.world.localeCompare(b.world),
        defaultSortOrder: 'desc', // Isso vai ordenar a tabela pela coluna "Mundo" quando carregada
      },
      {
        title: "",
        dataIndex: "delete",
        width: 35,
        render: (_, record) => (
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={async () => {
              try {
                // Deleta o jogador no backend
                await axios.delete(`${endpoints.semGuildEndpoint}/${encodeURIComponent(record.name)}`);
                
                // Atualiza a lista localmente
                updateSemGuildList(prev => prev.filter(p => p.name !== record.name)); // Atualiza o estado no componente pai

                // Atualiza outra lista, se necessário
                setPlayers(prev => prev.filter(p => p.name !== record.name));
                
                message.success("Removido com sucesso.");
                fetchGuildMembers("");  // Recarrega a lista de sem guild
              } catch {
                message.error("Erro ao remover jogador.");
              }
            }}
          />
        ),
      },
    ]
  : columns;

  const rowSelection = {
    selectedRowKeys: selectedPlayers,
    onChange: handlePlayerSelection,
    getCheckboxProps: (record) => ({
      disabled: !!classificacoes[record.name] && classificacoes[record.name].guild === guild
    })
  };

  const treeData = CLASS_TYPES.map(tipo => {
    const filtered = Object.entries(classificacoes)
      .filter(([_, val]) => val.tipo === tipo && val.guild === guild && _.toLowerCase().includes(treeSearch.toLowerCase()));

    return {
      title: `${tipo} (${filtered.length})`,
      key: tipo,
      children: filtered.map(([name, data]) => ({
        title: (
          <Checkbox
            checked={selectedClassified.includes(name)}
            onChange={e => {
              if (e.target.checked) {
                setSelectedClassified(prev => [...prev, name]);
              } else {
                setSelectedClassified(prev => prev.filter(n => n !== name));
              }
            }}
          >
            <b>{name}</b> - Lvl {data.level}, {data.vocation}
          </Checkbox>
        ),
        key: name
      }))
    };
  });

  return (
    <Modal
      title="Edit Enemy List"
      open={visible}
      onCancel={handleClose}
      width={1200}
      footer={null}
      style={{ maxWidth: "95%", margin: "auto" }}
      styles={{
        body: {
          maxHeight: '75vh',
          overflowY: 'auto',
          padding: 15,
          borderRadius: 10,
        },
      }}
    >
      {!authenticated ? (
        // Tela de autenticação
        <div style={{ textAlign: "center", marginTop: 10 }}>
          <div style={{ maxWidth: 300, margin: "auto" }}>
            <Input
              placeholder="ID"
              value={id}
              onChange={(e) => setId(e.target.value)}
              style={{ marginBottom: 8 }}
            />
            <Input.Password
              placeholder="Senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              style={{ marginBottom: 16 }}
            />
            <Button type="primary" block onClick={() => handleAuthentication()}>
              Autenticar
            </Button>
          </div>
        </div>
      ) : (
        // Tela principal depois de autenticado
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {/* Lado Esquerdo */}
          <div style={{ flex: 1, minWidth: "45%", overflow: "auto", padding: 16, borderRadius: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16 }}>
            <Radio.Group
              value={guild}
              onChange={(e) => {
                if (!loading) setGuild(e.target.value); // impede mudança se estiver carregando
              }}
              size="small"
            >
              <Radio.Button value="Eternity" disabled={loading}>Eternity</Radio.Button>
              <Radio.Button value="Namelesss" disabled={loading}>Namelesss</Radio.Button>
              <Radio.Button value="" disabled={loading}>Sem Guild</Radio.Button>
              {guild === "" && (
                <Button
                  type="primary"
                  style={{marginLeft: 5}}
                  size="small"
                  onClick={() => {
                    setSearchTerm("");
                    setSearchResult(null);
                    setIsModalVisible(true);
                  }}
                >
                  +
                </Button>
              )}
            </Radio.Group>
            <Input
              placeholder="Pesquisar por nome"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{ width: 220 }}
              size="small"
            />

<Modal
  title="Add character sem guild"
  width={400}
  open={isModalVisible}  // Controle do estado do modal interno
  onCancel={(e) => {
    e.stopPropagation();  // Impede que o clique no 'x' do modal pai feche o modal pai
    setIsModalVisible(false);  // Fecha o modal interno
    setModalSearchTerm("");    // Limpa o termo de busca
    setSearchResult(null);     // Limpa o resultado da busca
    setIsSearching(false);     // Desativa o loading
  }}
  footer={null}
>
  <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
    <Input
      placeholder="Character name"
      value={modalSearchTerm}
      onChange={(e) => setModalSearchTerm(e.target.value)}
    />
    <Button
      type="primary"
      icon={<SearchOutlined />}
      loading={isSearching}
      onClick={async () => {
        const value = modalSearchTerm.trim();

        if (value.length === 0) {
          message.warning("Digite o nome de um jogador.");
          setSearchResult(null);
          return;
        }

        setIsSearching(true); // Ativa o loading

        try {
          const res = await axios.get(`https://api.tibiadata.com/v4/character/${encodeURIComponent(value)}`);
          const char = res.data.character.character;

          const guildsPermitidas = ['Eternity', 'Namelesss', 'Watch Os', 'Unstopables'];

          if (char.guild?.name && !guildsPermitidas.includes(char.guild.name)) {
            // Permitir adicionar o jogador
          } else if (char.guild?.name) {
            message.warning("Esse jogador pertence a uma guild.");
            setSearchResult(null);
            return;
          }

          if (char.world !== "Solidera" && char.world !== "Havera") {
            message.warning("Esse jogador não é dos mundos Solidera ou Havera.");
            setSearchResult(null);
            return;
          }

          setSearchResult({
            name: char.name,
            vocation: char.vocation,
            level: char.level,
            world: char.world
          });

        } catch {
          message.error("Erro ao buscar jogador. Verifique o nome digitado.");
          setSearchResult(null);
        } finally {
          setIsSearching(false); // Desativa o loading
        }
      }}
    >

    </Button>
  </div>

  {searchResult && (
    <div style={{ padding: 8, borderRadius: 6, marginBottom: 16 }}>
      <p><strong>Nome:</strong> {searchResult.name}</p>
      <p><strong>Vocação:</strong> {searchResult.vocation}</p>
      <p><strong>Nível:</strong> {searchResult.level}</p>
      <p><strong>Mundo:</strong> {searchResult.world}</p>
      <Button
        type="primary"
        onClick={(e) => {
          e.stopPropagation();  // Impede que o clique no botão de salvar feche o modal pai
          handleSave();  // Chama a função de salvamento
        }}
        loading={isSaving}  // Exibe o spinner enquanto isSaving for true
      >
        Save
      </Button>
    </div>
  )}
</Modal>

      </div>
  
            {loading ? (
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: 16 }}>
                <Spin size="large" />
                <div style={{ marginTop: 8, fontSize: 16, color: "#1890ff" }}>
                  Loading...
                </div>
              </div>
            ) : (
              <>
                <Table
                  rowKey="name"
                  columns={columnsFinal}
                  dataSource={filteredPlayers}
                  pagination={{ pageSize: 10, showSizeChanger: false }}
                  rowSelection={rowSelection}
                  scroll={{ y: 350 }}
                  size="small"
                  style={{ marginBottom: 16 }}
                />

  
                {selectedPlayers.length > 0 && (
                  <div style={{ marginTop: 20 }}>
                    <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
                      {CLASS_TYPES.map(tipo => (
                        <Button
                          key={tipo}
                          size="small"
                          onClick={() => handleConfirmClassification(tipo)}
                          disabled={!selectedPlayers.length}
                          style={{ borderRadius: 4, fontWeight: 600 }}
                        >
                          {tipo}
                        </Button>
                      ))}
                    </div>
  
                    <div style={{ maxHeight: 200, overflowY: "auto", padding: 4, border: "1px solid #d9d9d9", borderRadius: 4 }}>
                      {selectedPlayers.map((playerName, index) => {
                        const playerData = players.find(p => p.name === playerName);
                        if (!playerData) return null;
  
                        return (
                          <div
                            key={playerName}
                            style={{
                              padding: "4px 8px",
                              borderRadius: 4,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: 4,
                              transition: "background-color 0.3s ease",
                            }}
                          >
                            <span>
                              {index + 1} - <b>{playerData.name}</b> - Lvl {playerData.level}, {playerData.vocation}
                            </span>
                            <Button
                              type="link"
                              size="small"
                              danger
                              onClick={() => {
                                setSelectedPlayers(prev => prev.filter(name => name !== playerName));
                              }}
                              icon={<DeleteOutlined />}
                              style={{ marginLeft: 8, padding: 0 }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
  
          {/* Separador */}
          <div style={{ width: 1, backgroundColor: "#d9d9d9", margin: "0 8px" }} />
  
          {/* Lado Direito */}
          <div style={{ flex: 1, minWidth: "45%", overflow: "auto", padding: 16, borderRadius: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 16, width: 220 }}>
              <Input
                placeholder="Pesquisar por nome"
                value={treeSearch}
                onChange={e => setTreeSearch(e.target.value)}
                style={{ flex: 1, marginRight: 10 }}
                size="small"
              />
            </div>
  
            <Checkbox
              checked={selectedClassified.length === Object.keys(classificacoes).filter(name => classificacoes[name].guild === guild).length}
              onChange={e => {
                if (e.target.checked) {
                  setSelectedClassified(Object.keys(classificacoes).filter(name => classificacoes[name].guild === guild));
                } else {
                  setSelectedClassified([]);
                }
              }}
            >
              All
            </Checkbox>
            <Button
              danger
              size="small"
              onClick={handleRemoveMultiple}
              disabled={!selectedClassified.length}
              icon={<DeleteOutlined />}
              style={{ marginLeft: 10 }}
            />
            <div style={{ maxHeight: 350, overflow: "auto", marginTop: 10 }}>
              <Tree treeData={treeData} defaultExpandAll />
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
  
}